import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

import { VideoFragment } from '@app-graphql/schema'
import { ComponentWithTextComponent } from '@app-domains/content-blocks/components/component-with-text/component-with-text.component'

@Component({
    selector: 'app-video-with-text',
    templateUrl: './video-with-text.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class VideoWithTextComponent extends ComponentWithTextComponent {
    @Input()
    public video: VideoFragment
}
